import { savedPaymentProfileEntryStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/SavedPaymentProfileEntry";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

Object.assign(savedPaymentProfileEntryStyles, {
    tokenExFrameWrapper: {
        css: css`
            height: inherit;
        `,
    },
    securityCodeHelpModalImageWrapper: {
        css: css`
            display: flex;
            justify-content: center;
        `,
    },
    text: {
        cssOverrides: {
            formField: css`
                input {
                    border-radius: 4px !important;
                }
            `,
        },
    },
});
